import { render, staticRenderFns } from "./reportAlarm.vue?vue&type=template&id=c52f3762&"
import script from "./reportAlarm.vue?vue&type=script&lang=js&"
export * from "./reportAlarm.vue?vue&type=script&lang=js&"
import style0 from "./reportAlarm.vue?vue&type=style&index=0&id=c52f3762&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports